import { render, staticRenderFns } from "./ActionSheetSender.vue?vue&type=template&id=1580a4e0"
import script from "./ActionSheetSender.vue?vue&type=script&lang=js"
export * from "./ActionSheetSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports